<template>
  <y-viewfrs :dataviewfrs="datos"></y-viewfrs>
</template>

<script>
import apiServices from "@/services/yungol-services";
import yViewfrs from "@/components/frs/Viewfrs.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      datos: {}
    };
  },
  computed: {
    ...mapState(["idtoken"]),
    routestateid(){
      return this.$route.params.id;
    }
  },
  methods: {
    async traeData(_this) {
      let result;
      try {
        if (_this.$route.params.id) {
          result = await apiServices.get(`/informefrs/${_this.$route.params.id}`);
        } else {
          result = await apiServices.get(`/informeprincipalfrs`);
        }
        _this.datos = result.data;
      } catch (err) {
        console.log(err);
      }
    }
  },
  watch: {
    idtoken(newv, oldv) {
      if (newv) {
        this.traeData(this);
      }
    },
    routestateid(nv,ov){
      this.traeData(this);
    }
  },
  created() {
    if (this.idtoken) {
      this.traeData(this);
    }
  },
  components: {
    yViewfrs
  }
};
</script>


// WEBPACK FOOTER //
// src/components/frs/Vfrs.vue